import { User } from "../../models/User";

export const transformUser = (data: any): User => {
  let fullname = "",
    firstName = "",
    lastName = "";

  if (data.trainee_name) {
    fullname = data.trainee_name as string;
    const parts = fullname.split(" ");
    firstName = parts[0] || "";
    lastName = parts[1] || "";
  }

  return {
    id: data.id || "",
    name: data.first_name
      ? `${data.first_name} ${data.last_name || ""}`.trim()
      : data.trainee_name || "",
    firstName: data.first_name || firstName || "",
    lastName: data.last_name || lastName || "",
    email: data.trainee_email || data.social_media_id || "",
    ageGroup: data.age_group || "",
    profileImage: data.profile_photo || "http://localhost:3000/img/dummy.jpg",
    profilePhoto: data.profile_photo || "http://localhost:3000/img/dummy.jpg", // Add profilePhoto
    organization: data.organization || "",
    facebook: data.facebookLink || "",
    instagram: data.instagramLink || "",
    youtube: data.youtubeLink || "",
    linkedIn: data.linkedinLink || "", // Use capital 'I' to match User interface
    profileMessage: data.hobbies || "",
    aboutMe: data.short_bio || "",
    website: data.website || "",
    industry: data.industry || "",
    designation: data.role || "",
    city: data.town_city || "",
    country: data.country || "",
  } as User;
};
